import Image from 'next/image';
import Icon from './amazon_red.svg?url';
import type { SvgImageProps } from '../_type';

export const AmazonRedImage: React.FC<SvgImageProps> = ({ alt, ...props }) => (
  <Image src={Icon} alt={alt} {...props} />
);
